module.exports = __webpack_public_path__ + "media/svg/neutral_light_vertical-ac19cff6.svg";